// Application bundle - matches Gulp app task
// This bundle includes all custom application JavaScript

// Import all modules statically to bundle them into a single file
import '../statehelper.js';
import '../profile.js';
import '../vimeo.js';
import '../attendance.js';
import '../showMoreProfiles.js';
import '../links.js';
import '../filterBar.js';
import '../quiz.js';
import '../jquery.spin.js';
import '../header.js';
import '../home.js';
import '../modalFeedbackForm.js';
import '../statehelperActivities.js';
import '../statehelperProgress.js';
import '../outline.js';
import '../loginForm.js';
import '../contactForm.js';
import '../kt.js';
import '../scenario.js';
import '../modalSwitchPathway.js';
import '../statehelperPathways.js';

console.log('App bundle starting - waiting for thirdparty...');

// Wait for thirdparty bundle to signal it's ready
function waitForThirdparty() {
  return new Promise((resolve) => {
    if (window.thirdpartyReady) {
      console.log('Thirdparty already ready, proceeding...');
      resolve();
    } else {
      console.log('Waiting for thirdparty ready event...');
      window.addEventListener('thirdpartyReady', () => {
        console.log('Thirdparty ready event received, proceeding...');
        resolve();
      }, { once: true });
    }
  });
}

// Initialize custom modules after thirdparty is ready
async function initializeCustomModules() {
  try {
    await waitForThirdparty();
    console.log('All custom JavaScript modules loaded and ready');
  } catch (error) {
    console.error('Error initializing custom modules:', error);
  }
}

// Start initializing custom modules
initializeCustomModules();